import gql from 'graphql-tag'

export interface ITourOpening {
  id: string
  availabilityIds: number[]
  date: string
  beginsAt: string
  endsAt: string
  isSchedulable: boolean
}

export const TourOpeningFieldsFragment = gql`
  fragment TourOpeningFields on TourOpening {
    id
    availabilityIds
    date
    beginsAt
    endsAt
    isSchedulable
  }
`
